const base = require("./base");
module.exports = {
  ...base.apiFactory(),
  app: "http://dsp-server.cj-1.com/",
  erp: "http://cucheng-erp-web.cj-1.com/",
  storage: "http://cucheng-storage-web.cj-1.com/",
  freightService: "http://192.168.5.149:8000/",
  cujiaLogisticsFreight: "http://192.168.5.197:8058/",
  tool: "http://cucheng-tool-web.cj-1.com/",
  caigou: "http://cucheng-procurement-web.cj-1.com/",
  order: "http://cucheng-order-web.cj-1.com/",
  cj: "http://cucheng-app-web.cj-1.com/", //app1.test.com
  source: "http://cucheng-source-web.cj-1.com/",
  freight: "http://transit-logistics.cj-1.com/",
  authorize: "http://cujia-platform-web-authorize.cj-1.com/",
  ebay: "http://eaby.cj-1.com/",
  lazada: "http://lazada.cj-1.com/",
  shopee: "http://shopee.cj-1.com/",
  woo: "http://woocommerce.cj-1.com/",
  newlogistics: "http://cucheng-logistics-web.cj-1.com/",
  _logistics_190606: "http://dsp-logist.test.com/", //http://logistics.test.com/
  _chat_190606: "https://test-frontend.cjdropshipping.com/chat/",
  listed_products: "http://listed-products.cj-1.com/",
  _affiliate3_190606: "https://affiliate3.cjdropshipping.com/", //http://affiliate3.test.com/
  _phone_190606: "http://m-web.cj-1.com/",
  storehousecj: "http://cujia-storehouse-cj-web.cj-1.com/",
  warehouseBuildWeb: "http://cujia-storehouse-build-web.cj-1.com/",
  storehouse: "http://cujia-storehouse-web.cj-1.com/",
  media: "http://cujia-order-media-web.cj-1.com/",
  erpSupplierSourceProduct: "http://cj-supplier-erp.cj-1.com/",
  supplierPlanInfo: "http://cj-supplier-web.cj-1.com/",
  cjSupplier: "http://cj-supplier-erp.cj-1.com/",
  cjEvaluation: "http://cj-supplier-erp.cj-1.com/",
  cujialog: "http://192.168.5.197:8831/",
  supplier: "http://192.168.5.239:8092/",
  comment: "http://192.168.5.197:7612/",
  "platform-shop": "http://192.168.5.197:7610/",
  _elites_200812: "http://192.168.5.37:8081/",
  "platform-product": "http://192.168.5.197:7612/",
  collection: "http://collection.test.com/",
  messageCenterCj: "http://master.backend-cujia-message-center.cj.com/",
  "product-api": "http://release.cjproductcenter.cj.com/",
  "elastic-api": "http://192.168.3.27:31451/",
  "productSku": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "productDetail": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  operation: "http://192.168.5.197:8058/cujiaLogisticsFreight/",
  operationCenterApi: "http://master.backend-cj-operation-center.cj.com/",
  statistics: "http://192.168.5.197:8025/",
  "product-integration-api": "http://product-center.cj.com/",
  "order-center": "http://master.backend-cj-order.cj.com/",
  _cjpacket_210408: "https://logistics.cjdropshipping.com/",
  "early-warning-web": "http://master.backend-home-center.cj.com/",
  "cujia-message": "http://master.backendcujiamessagecenter.cj.com/",
  "cj-logistics-rule": "http://master.logistic.cj.com/",
  payment: "http://192.168.5.197:8066/", // 支付
  wallet: "https://payment.cjdropshipping.cn/", // 钱包
  messageCenterWeb: "http://master.backend-cujia-message-center.cj.com/",
  operationCenterWeb: "http://www.cjdropshipping.offline.pre.com/",
  invoice: "http://master.finance.cj.com/cujia-finance-web/",
  api: "http://master.cjcostcenter.cj.com/",
  userAuthorityCenterWeb: "http://master.backend-cujia-user-center.cj.com/",
  "cujia-finance-web": "http://master.finance.cj.com/",
  payCenterLs: "https://payment.cjdropshipping.cn/", // 获取支付账单接口-临时调配host
  "storehouse-center-web": "http://wmss.test.com/",
  "cjorder-web": "http://master.backendcjorder.cj.com/", // 履约服务接口
  "product-app-api": "http://product-center.cj.com/", //履约服务获取变体接口
  "cj-platform-web": "http://master.backendcjplatformcenter.cj.com/",
  "source-rest-api": "http://source-center.cj.com/",
  "payment-center-web": "http://master.payment.cj.com/",
  "platform-order": "http://192.168.5.197:7613/",
  userCenterForeignWeb: "http://master.backend-cujia-user-center.cj.com/",
  "quick-search-product-center": "http://www.cjdropshipping.offline.pre.com/",
  "cj-logistics-api": "http://master.backendlogisticscenter.cj.com/",
  "chat-web": "http://master.cjmessagecenter.cj.com/",
  "supplier-center-web": "http://supplier.test.com/",
  "affiliate-center-web": "http://master.jobs.cj.com/",
  "forum-center-web": "http://www.cjdropshipping.offline.pre.com/",
};
